export default function Offers() {
    const offers = ["Product Design","Manufacturing","Logistics"];
    return (
        <section id="offers" className="bg-light-gray">
            <div className="container">
                <h2 className="section-title">What We Offer</h2>
                <div className="row text-center">
                    {offers.map((o,i)=>(
                        <div key={i} className="col-md-4 my-3">
                            <div className="card p-3">{o}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
